import { once } from 'lodash';
import * as appLifecycleService from '../services/app-lifecycle-service';
import { createFedopsLogger } from '../services/create-fedops-logger';

export const APPLICATION_LOADED = 'application/LOADED';

const triggerFedopsAppLoadedOnce = once(fedopsLogger => fedopsLogger.appLoaded());
const triggerBiAppLoadedOnce = once(appLifecycleService => appLifecycleService.appLoaded());

export const applicationLoaded = () => {
  const fedopsLogger = createFedopsLogger();
  return () => {
    triggerFedopsAppLoadedOnce(fedopsLogger);
    triggerBiAppLoadedOnce(appLifecycleService);
    return { type: APPLICATION_LOADED };
  };
};
